import { Transition } from "@headlessui/react";
import {
  panelClasses,
  vn_simple_rounded,
  search_agent_standard,
  company_agent_standard,
} from "../utils/constants";

export const AgentIcon = ({ agent, size = 56 }) => {
  if (agent === "wwwsearch") {
    return (
      <img
        src={search_agent_standard}
        alt="Code agent"
        style={{ width: size, height: size }}
        className="rounded-full p-1"
      />
    );
  }
  if (agent === "hybrid") {
    return (
      <img
        src={company_agent_standard}
        alt="Hybrid agent"
        style={{ width: size, height: size }}
        className="rounded-full p-1"
      />
    );
  }
  return (
    <img
      src={vn_simple_rounded}
      alt="Default agent"
      style={{ width: size, height: size }}
      className="rounded-full p-1"
    />
  );
};

const DropDownAgentSelector = (props) => {
  const handleToggle = () => {
    props.setIsAgentSelectorOpen(!props.isAgentSelectorOpen);
    props.setIsDropDownNotesOpen(false);
    props.setIsPromptLoaderOpen(false);
  };

  return (
    <div>
      <button
        onClick={handleToggle}
        className="inline-flex items-center gap-1.5 py-1 text-mutedText hover:text-mainText transition-colors font-light cursor-pointer"
      >
        <img src={vn_simple_rounded} alt="" className="h-5 w-5 rounded-full" />
        <span className="text-[13px]">{props.selectedAgent?.name}</span>
      </button>

      <Transition
        show={props.isAgentSelectorOpen}
        enter="transition duration-150 ease-out"
        enterFrom="opacity-0 translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="transition duration-100 ease-in"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <div className="absolute left-0 right-0 bottom-full z-[70]">
          <div className={panelClasses}>
            <div className="max-h-[50vh] overflow-auto p-2">
              <ul className="space-y-0.5">
                {props.agents.map((agent) => {
                  const selected =
                    props.selectedAgent?.apiName === agent.apiName;

                  return (
                    <li key={agent.apiName}>
                      <button
                        onClick={() => {
                          props.setSelectedAgent(agent);
                          props.setIsAgentSelectorOpen(false);
                        }}
                        className={[
                          "group flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left transition-colors cursor-pointer",
                          selected ? "bg-velBlue/10" : "hover:bg-btnHover",
                        ].join(" ")}
                      >
                        <span className="shrink-0">
                          <AgentIcon agent={agent.apiName} />
                        </span>

                        <div className="min-w-0 flex-1">
                          <div className="flex items-center gap-2">
                            <p className="truncate text-[13px] font-light text-mainText">
                              {agent.name}
                            </p>
                            {selected && (
                              <span className="rounded-full bg-velBlue/15 px-2 py-px text-[10px] font-light text-velBlue uppercase tracking-wider">
                                Active
                              </span>
                            )}
                          </div>
                          <p className="mt-0.5 text-[12px] font-light text-mutedText line-clamp-1">
                            {agent.description}
                          </p>
                        </div>
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default DropDownAgentSelector;
